import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { projectType, menuItemType } from 'types';
import LinkedMenuItem from 'components/Sidebar/components/LinkedMenuItem';
import MenuItem from 'components/Sidebar/components/MenuItem';

import './style.scss';

/* eslint-disable react/no-array-index-key */
const SidebarSubmenu = ({ group, currentProject, isOpen }) => (
  <div styleName={cn('submenu', { 'is-open': isOpen })}>
    {isOpen && <span styleName="group">{group.title}</span>}
    {group.children.map((item, index) => (
      <LinkedMenuItem key={index} currentProject={currentProject} item={item}>
        <MenuItem isOpen={isOpen} item={item} />
      </LinkedMenuItem>
    ))}
  </div>
);

SidebarSubmenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  group: PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.arrayOf(menuItemType),
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  currentProject: projectType.isRequired,
};

export default SidebarSubmenu;
